import React, { Component } from 'react'
import StagesManager from '../StagesManager';
import StartQuiz from '../../windows/Applets/inquiries/StartQuiz';
import Quiz from '../../windows/Applets/inquiries/Quiz';
import EndQuiz from '../../windows/Applets/inquiries/EndQuiz';
import UserRecent from '../../windows/Applets/inquiries/UserRecent';
import HttpServices from '../../utils/Http.services';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import { checkTranslation, chooseFontColor, msToHMS, translate } from '../../utils/useful';
import ButtonAnimated from '../buttons/ButtonAnimated';
import CustomLoader from '../CustomLoader';
import Responsive from '../Responsive';
import tableComponents from './../tableComponents'

import moment from 'moment';
import QuizPage from '../../windows/Applets/inquiries/QuizPage';

class QuizPageWidget extends Component {

    state = {
        backbtn: true,
        colors: {
            primaryColor: '#6E9318',
            secondaryColor: '#96C723',
            textColor: '#fff'
        },
        showToolbar: true
    }

    componentDidUpdate(prevProps) {
        if (JSON.stringify(this.props.params) != JSON.stringify(prevProps.params)) {
            this.init()
        }
    }

    componentDidMount() {
        this.stageManager.changeStage('startQuiz', (cb) => {
            this.init()
        })
    }

    init() {


        let data = { ...this.props.data }
        console.log('dataaaaq', data)
        if (this.props.data) {
            // data.view.type = 'card'
            // this.setState({ data })
            let cardElements = []
            let cardInfo = data.view?.settings?.cardInfo

            if (cardInfo && Array.isArray(cardInfo)) {
                cardInfo.forEach((element, index) => {
                    cardElements.push(element)
                });
            }
            this.setState({ cardElements })
        }
        let quiz
        let current
        let allQuizes
        this.props.params?.forEach((param) => {
            quiz = param.info ?? {}
            allQuizes = param.allQuizes
            current = param.current
        })

        this.setState({ information: data, quiz, current, allQuizes })
        // let body = { collection: data.collection }
        this.setState({ isLoading: true })
        // HttpServices.request("getFrame", body, (fetchResult, fetchError, status) => {
        //     this.setState({ isLoading: false })
        //     if (fetchError) { return }
        //     let frame = fetchResult?.info
        //     frame.key = frame._id
        //     frame.section = 'collections'
        //     frame.pageType = 'collection'
        //     frame.fetchUrl = 'getRecord'
        //     frame.addUrl = 'postRecord'
        //     frame.editUrl = 'postRecord'
        //     frame.removeUrl = 'removeRecord'
        //     frame.postBody = { hub: frame?.applet?.hub, applet: frame?.applet?._id }
        //     frame.filter = { hub: frame?.applet?.hub, applet: frame?.applet?._id }
        //     frame.fields.forEach(field => {
        //         if (!field.key.includes("values.")) {
        //             field.key = "values." + field.key
        //         }
        //     });
        //     this.setState({ frame: frame }, () => {
        //         let body = frame.filter ? { ...frame.filter } : {}
        //         body.limit = this.state.limit
        //         body.skip = this.state.skip
        //         for (const [key, value] of Object.entries(body)) {
        //             if (/\{\{(.*?)\}\}/.test(value)) {
        //                 if (this.props.variables) {
        //                     body[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
        //                 }
        //             }
        //         }
        //         body.frame = frame?._id
        //         this.setState({ isLoadingData: true })
        //         console.log('body',body)
        //         HttpServices.request(frame.fetchUrl, body, (recordsFetchResult, fetchError) => {
        //             this.setState({ isLoadingData: false })
        //             if (fetchError) {
        //                 this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
        //                 return
        //             }
        //             this.setState({ showTable: false }, () => {
        //                 this.setState({ data: recordsFetchResult.info, showTable: true }, () => {
        //                 })
        //             })
        //         })
        //     })
        // })

    }

    getRecords = () => {
        let data = { ... this.props.data }
        data.hub = this.props.user.info._id
        data.features = 'Inquiry'
        HttpServices.request('getRecords', data, ((fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            this.setState({ data: fetchResult.info })
        }))
    }

    getRecord = (id) => {
        let data = {}
        data._id = id
        HttpServices.request('getRecord', data, ((fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            this.setState({ id, quiz: fetchResult.info })
        }))
    }

    changeBackbtn = (check) => {
        this.setState({ backbtn: check }, () => {
        })
    }

    retake = () => {
        if (this.props.windowData.path && this.props.windowData?.path[3]) {
            this.getCurrentInquiry(this.props.windowData?.path[3])
            this.stageManager.changeStage('startQuiz')
        } else {
            this.stageManager.changeStage('start')
        }
    }

    getCurrentInquiry = (id) => {
        let data = {}
        data.inquiry = id
        HttpServices.request('getCurrentInquiry', data, (fetchResult, fetchError) => {
            this.setState({ isLoading: false })
            if (fetchError) {
                return
            }
            this.setState({ current: fetchResult.info, })
        })
    }

    startQuiz = () => {
        this.stageManager.changeStage('quiz')
        // this.setState({ current: null })
    }

    endInquirie = () => {
        this.stageManager.changeStage('endpage')
    }

    endInquiry = () => {
        console.log('this.props.windowData', this.props.windowData)
        console.log('this.props', this.props)
        // return
        HttpServices.request('endInquiry', { inquiry: this.props.windowData?.path[3], applet: this.props.applet._id ?? this.props.applet }, ((fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            if (!this.state.current) {
                this.setState({ current: fetchResult.info })
            }
        }))
        this.endInquirie()
    }

    changeQuizPage = (page) => {
        let newLink = []
        let slug = this.state.frame?.applet?.slug
        newLink.push(slug)


        console.log('changeQuizPage1', page)
        console.log('changeQuizPage2', this.props)
        console.log('changeQuizPage3', this.state)
        // let path;
        if (page) {
            if (Array.isArray(page)) {
                page.forEach(el => {
                    newLink.push(el)
                })
                // path = page;
            } else {
                newLink.push(page?.key ?? page)
                // path = [page?.key ?? page];
            }
        }
        this.props.pageChangePage(newLink);
    }

    backStage = () => {
        this.stageManager.lastStage((stage) => {
            let showToolbar = false
            let shouldHaveToolbar = ['start', 0]
            if (shouldHaveToolbar.includes(stage)) {
                showToolbar = true
            }
            let showBackBtn = true
            let shouldHaveBackBtn = ['start', 0]
            if (shouldHaveBackBtn.includes(stage)) {
                showBackBtn = false
            }
            this.setState({ showToolbar, showBackBtn })
        })
    }

    changePage = (stage) => {
        let showToolbar = false
        let shouldHaveToolbar = ['start',]
        if (shouldHaveToolbar.includes(stage)) {
            showToolbar = true
        }
        let showBackBtn = true
        let shouldHaveBackBtn = ['start',]
        if (shouldHaveBackBtn.includes(stage)) {
            showBackBtn = false
            this.setState({ data: {} })
        }
        this.stageManager.changeStage(stage)
        this.setState({ showToolbar, showBackBtn })
    }

    backToQuizPage = () => {
        this.stageManager.changeStage('start')
        this.props.changeWindowLink([]);
    }

    changeView = () => {
        this.setState({ viewMode: !this.state.viewMode })
    }

    render() {
        let colors = this.state.colors ?? {}
        let applet = this.props.applet
        if (applet?.colorType == 'sameAsHub') {
        }
        if (applet?.colorType == "custom") {
            colors = applet?.colors
        }
        if (!colors?.textColor) {
            colors.textColor = '#fff'
        }
        let iconInvert = chooseFontColor(colors.textColor) == '#fff' ? true : false
        colors.iconInvert = iconInvert
        colors.background = `linear-gradient(90deg, ${colors.primaryColor}, ${colors.secondaryColor})`
        return (
            <div className='d-flex w-100 h-100 window-content-radius ' style={{ display: 'block', backgroundColor: '#fff' }}>
                <div className="w-100  h-100  window-content-radius d-flex flex-column " ref={el => this.pageContainer = el} style={{}} >

                    <StagesManager ref={el => this.stageManager = el} fast={true} height={'0px'} className={'flex-1'}  >
                        {/* <div className='scroll-no-scrollbar h-100 ' stage={0} stageName='start'>
                            <div className=''>
                                <div className='w-100 d-flex flex-column  '>
                                    <div className='flexcb w-100 px-2 mx-2 pt-2 mt-2'>
                                        <p className='font-size-18 weight-700 main-c3'>{translate("Available Inquiries")}</p>
                                        <button className='mx-3 hover-gray p-1 br-5' onClick={() => this.changeView()}>
                                            <img className='flexcc' width={24} src={!this.state.viewMode ? '/assets/icons/note/listview.svg' : '/assets/icons/note/tableview.svg'} />
                                        </button>
                                    </div>
                                    {this.state.data ?
                                        !this.state.viewMode ? (
                                            <div className='d-flex flex-wrap m-2'>
                                                {Array.isArray(this.state.data) && this.state.data.length > 0 ?
                                                    (this.state.data.map((item, index) => {
                                                        let duration = item.values?.duration
                                                        if (Array.isArray(duration) && duration.length > 0) {
                                                            duration = duration[0] + ':' + duration[1] + ':' + duration[2]
                                                        }
                                                        return (
                                                            <Responsive width={this.props.width} media={{ xs: '12', 530: '6', 770: '4', 1000: '3', 1500: '2' }}>
                                                                <div className='bg-white shadow-2 p-3 br-10 m-2' style={{}}>
                                                                    <div className='w-100'>
                                                                        <div className='flexcc flex-column'>
                                                                            <div>
                                                                                <img className='br-50' width={80} src='/images/p4.png' />
                                                                            </div>
                                                                            <div className='flexcc flex-column pt-2'>
                                                                                <div className='pt-2 flexcc flex-column' style={{}}>
                                                                                    {this.state.cardElements?.map((header, hindex) => {
                                                                                        let Component = tableComponents[header.type]
                                                                                        let data = header.data
                                                                                        let styleInfo
                                                                                        if (this.state.data?.view?.settings?.cardInfo) {
                                                                                            styleInfo = this.state.data?.view?.settings?.cardInfo[header.key]
                                                                                        } else {
                                                                                            if (header.type == 'TextAreaInput') {
                                                                                                styleInfo = { fontSize: 14 }
                                                                                            }
                                                                                            if (header.type == 'TextInput') {
                                                                                                styleInfo = { fontSize: 16, fontWeight: 500 }
                                                                                            }
                                                                                        }
                                                                                        if (header.type == 'ButtonInput') {
                                                                                            header.information.label = translate('Start')
                                                                                            styleInfo = { background: this.props.colors ? this.props.colors?.background : 'linear-gradient(90deg, #6E9318, #96C723)', width: '100%', color: this.props.colors ? this.props.colors?.textColor : '#fff', borderRadius: '30px', minHeight: '30px', fontSize: '14px', fontWeight: 600 }
                                                                                            return (
                                                                                                < div className='component-container mb-1 w-100 flexcc pt-2' style={{ fontSize: 14 }}>
                                                                                                    {Component && (
                                                                                                        <Component data={data} header={header} changeValue={this.changeValue} extra={{ index: hindex, _id: item._id }} styleInfo={styleInfo} headers={this.props.headers} fullData={item} onClick={() => this.changeQuizPage(['quiz', item._id], ['startQuiz'])} />
                                                                                                    )}
                                                                                                </div>
                                                                                            )
                                                                                        }
                                                                                        else {
                                                                                            return (
                                                                                                <div className='component-container mb-1 w-100' style={{ fontSize: 14 }}>
                                                                                                    {Component && (
                                                                                                        <Component data={data} header={header} changeValue={this.changeValue} extra={{ index: hindex, _id: item._id }} styleInfo={styleInfo} headers={this.props.headers} fullData={item} />
                                                                                                    )}
                                                                                                </div>
                                                                                            )
                                                                                        }
                                                                                    })}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Responsive>
                                                        )
                                                    })) : (
                                                        <div className='h-100 w-100 flexcc pt-5'>
                                                            <p>{translate('There is no inquiries.')}</p>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        ) : (
                                            <div className='d-flex flex-wrap m-2'>
                                                {Array.isArray(this.state.data) && this.state.data.length > 0 ?
                                                    (this.state.data.map((item, index) => {
                                                        return (
                                                            <Responsive width={this.props.width} media={{ xs: '12', 500: '6', 700: '6', 1000: '4', 1500: '4' }}>
                                                                <div className='bg-white shadow-2 p-3 br-10 m-2' onClick={() => this.changeQuizPage(['quiz', item._id], ['startQuiz'])}>
                                                                    <div className='w-100'>
                                                                        <div className='flexc'>
                                                                            <div>
                                                                                <img className='br-50' width={80} src='/images/p4.png' />
                                                                            </div>
                                                                            <div className='d-flex flex-column mld-3 text-start w-100'>
                                                                                <div className='pt-2'>
                                                                                    {this.state.cardElements?.map((header, hindex) => {
                                                                                        let Component = tableComponents[header.type]
                                                                                        let data = header.data
                                                                                        let styleInfo
                                                                                        if (this.state.data?.view?.settings?.cardInfo) {
                                                                                            styleInfo = this.state.data?.view?.settings?.cardInfo[header.key]
                                                                                        } else {
                                                                                            if (header.type == 'TextAreaInput') {
                                                                                                styleInfo = { fontSize: 14 }
                                                                                            }
                                                                                            if (header.type == 'TextInput') {
                                                                                                styleInfo = { fontSize: 16, fontWeight: 500 }
                                                                                            }
                                                                                        }
                                                                                        if (header.type == 'ButtonInput') {
                                                                                            header.information.label = translate('Start')
                                                                                            styleInfo = { background: this.props.colors ? this.props.colors?.background : 'linear-gradient(90deg, #6E9318, #96C723)', width: '100%', color: this.props.colors ? this.props.colors?.textColor : '#fff', borderRadius: '30px', minHeight: '30px', fontSize: '14px', fontWeight: 600 }
                                                                                            return (
                                                                                                <div className='component-container mb-1 w-100 flexcc' style={{ fontSize: 14 }}>
                                                                                                    {Component && (
                                                                                                        <Component data={data} header={header} changeValue={this.changeValue} extra={{ index: hindex, _id: item._id }} styleInfo={styleInfo} headers={this.props.headers} fullData={item} onClick={() => this.changeQuizPage(['quiz', item._id], ['startQuiz'])} />
                                                                                                    )}
                                                                                                </div>
                                                                                            )
                                                                                        }
                                                                                        else {
                                                                                            return (
                                                                                                <div className='component-container mb-1 w-100' style={{ fontSize: 14 }}>
                                                                                                    {Component && (
                                                                                                        <Component data={data} header={header} changeValue={this.changeValue} extra={{ index: hindex, _id: item._id }} styleInfo={styleInfo} headers={this.props.headers} fullData={item} />
                                                                                                    )}
                                                                                                </div>
                                                                                            )
                                                                                        }
                                                                                    })}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </Responsive>
                                                        )
                                                    })) : (
                                                        <div className='h-100 w-100 flexcc pt-5'>
                                                            <p>{translate('There is no inquiries.')}</p>
                                                        </div>
                                                    )
                                                }
                                            </div>
                                        ) :
                                        <div className='flexcc w-100 h-100 pt-5' style={{ width: '28px', }}>
                                            <CustomLoader color={this.props.colors ? this.props.colors.primaryColor : '#eee'} isLoading={true} width={27} type={"Oval"} className={'flexcc'} />
                                        </div>
                                    }
                                </div>
                            </div>
                        </div> */}
                        <StartQuiz stage={0} stageName={'startQuiz'} backStage={this.backStage} changeBackbtn={this.changeBackbtn} initData={this.state.data} setData={this.setData} width={this.props.width}
                            pages={this.state.pages}
                            quiz={this.state.quiz}
                            user={this.props.user}
                            startQuiz={this.startQuiz}
                            getOneInquiry={this.getOneInquiry}
                            endInquiry={this.endInquiry}
                            addNotif={this.addNotif}
                            variables={this.props.variables}
                            inquiry={this.state.inquiry}
                            questions={this.state.questions}
                            current={this.state.current}
                            allQuizes={this.state.allQuizes}
                            changePage={this.changePage}
                            changeQuizPage={this.changeQuizPage}
                            applet={this.props.applet}
                            language={this.props.language}
                            colors={this.props.colors}
                            setHeader={this.setHeader}
                            backToQuizPage={this.backToQuizPage}
                            windowData={this.props.windowData}
                        />
                        <Quiz stage={1} stageName={'quiz'} backStage={this.backStage} initData={this.state.data} setData={this.setData} width={this.props.width} height={this.props.height} data={this.props.data} changeWindow={this.props.changeWindow}
                            pages={this.state.pages}
                            user={this.props.user}
                            quiz={this.state.quiz}
                            changePage={this.changePage}
                            endInquiry={this.endInquiry}
                            addNotif={this.addNotif}
                            variables={this.props.variables}
                            inquiry={this.state.inquiry}
                            questions={this.state.questions}
                            current={this.state.current}
                            allQuizes={this.state.allQuizes}
                            applet={this.props.applet}
                            language={this.props.language}
                            colors={this.props.colors}
                            setHeader={this.setHeader}
                            backToQuizPage={this.backToQuizPage}
                        />
                        <EndQuiz stage={1} stageName={'endpage'} backStage={this.backStage} initData={this.state.data} setData={this.setData} width={this.props.width} height={this.props.height} data={this.props.data} changeWindow={this.props.changeWindow}
                            pages={this.state.pages}
                            user={this.props.user}
                            quiz={this.state.quiz}
                            changePage={this.changePage}
                            endInquiry={this.endInquiry}
                            retake={this.retake}
                            addNotif={this.addNotif}
                            variables={this.props.variables}
                            inquiry={this.state.inquiry}
                            questions={this.state.questions}
                            current={this.state.current}
                            applet={this.props.applet}
                            language={this.props.language}
                            colors={this.props.colors}
                            setHeader={this.setHeader}
                            backToQuizPage={this.backToQuizPage}
                        />
                    </StagesManager>
                </div >
            </div >
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(QuizPageWidget); 